/**
 * Eventos GTM
 */
export const EventosGtmSaesa = {
  mapaDesconexiones: {
    acceso: {
      evento: 'accesos_mapa',
      nombre: 'Acceso a mapa de desconexiones',
      categoria: 'mapa_desconexiones',
    },
    busqueda: {
      busquedaServicio: {
        evento: 'busqueda_servicio',
        nombre: 'Busqueda por numero de servicio',
        categoria: 'mapa_desconexiones',
      },
      busquedaServicioError: {
        evento: 'busqueda_servicio_error',
        nombre: 'Error en busqueda de servicio',
        categoria: 'mapa_desconexiones',
      },
      busquedaDireccion: {
        evento: 'busqueda_direccion',
        nombre: 'Busqueda por dirección',
        categoria: 'mapa_desconexiones',
      },
      busquedaDireccionError: {
        evento: 'busqueda_direccion_error',
        nombre: 'Error en Busqueda por dirección',
        categoria: 'mapa_desconexiones',
      },
    },
    reportarCorte: {
      evento: 'reportar_corte',
      nombre: 'Botón reportar corte',
      categoria: 'mapa_desconexiones',
    },
    poligono: {
      llamadaTracking: {
        evento: 'click_poligono',
        nombre: 'Click en poligono busqueda tracking',
        categoria: 'mapa_desconexiones',
      },
      cargaTracking: {
        evento: 'click_poligono_tracking',
        nombre: 'Información cargada desde tracking',
        categoria: 'mapa_desconexiones',
      },
      switchCortesFuturos: {
        evento: 'click_switch_cortes_futuros',
        nombre: 'Switch cortes futuros',
        categoria: 'mapa_desconexiones',
      },
    },
  },
};
